import { HttpResponse } from '@angular/common/http';

export class CachedResponse {
	identifier: string;
	expiryDate: Date;
	api: string;
	response: HttpResponse<any>;
}
